<script>
  import { onMount } from 'svelte';
  import Loader from '../../Common/Loader.svelte';
  import LmsCircleAnalytics from '../circles/LmsCircleAnalytics.svelte';
  import { LmsUtils } from '../utils/LmsUtils';

  export let circleDetails = null, entity = null, type = "CIRCLE";
  let loading = true;

  onMount(async () => {
    if (typeof circleDetails === 'string') {
      circleDetails = await LmsUtils.getCircleDetailsByUrl(circleDetails);
      entity = circleDetails.circle;
      type = 'CIRCLE';
    }
    loading = false;
  });
</script>

{#if loading}
  <Loader />
{:else}
  <div class="col20 f-left circle-content">
    <LmsCircleAnalytics circleDetails={circleDetails} entity={entity} type={type} />
  </div>
{/if}
